import { useMemo } from "react";
import { Report } from "@/types/evaluate";
const useTimestampProcessing = (reports: Report[] | undefined) => {
  return useMemo(() => {
    if (!reports) return { uniqueDates: [], labels: [], timestampIndexMap: {} };

    const allDates = reports
      .filter((r) => r.parent_report_id)
      .map((report) => new Date(report.created_at).getTime());

    const uniqueDates = [...new Set(allDates)].sort((a, b) => a - b);

    const labels = uniqueDates.map((timestamp) => {
      const date = new Date(timestamp);
      return new Intl.DateTimeFormat("en-US", {
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      }).format(date);
    });

    const timestampIndexMap = uniqueDates.reduce(
      (map, timestamp, index) => {
        map[timestamp] = index;
        return map;
      },
      {} as Record<number, number>,
    );

    return { uniqueDates, labels, timestampIndexMap };
  }, [reports]);
};

export default useTimestampProcessing;
